<template>
    <div class="px-5 py-0 space-y-3">
        <div
            v-for="value in values"
            :key="value.ulid"
            @click="handleClick(value)"
            :class="isSelected(value) ? selected : unselected"
            class="flex min-w-0 space-x-1"
        >
            <div class="shrink-0">
                <zen-icon-box-checked v-if="isSelected(value)" />
                <zen-icon-box-empty v-if="!isSelected(value)" />
            </div>
            <!-- wrap-anywhere keeps a long unbroken value (an email, a URL) inside the row; words still wrap at spaces first. -->
            <div class="min-w-0 wrap-anywhere">
                <span v-if="value.display != ''">
                    {{ value.display }}
                </span>
                <span v-if="value.display == ''" class="italic"> (empty) </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StringTargetToggle',
    computed: {
        selected() {
            return 'text-taupe-800'
        },
        unselected() {
            return (
                'text-taupe-500 ' +
                (this.readOnly
                    ? 'cursor-not-allowed'
                    : 'hover:text-sky-500 cursor-pointer')
            )
        },
    },
    methods: {
        isSelected(value) {
            return (
                this.currentValue != null &&
                this.currentValue.ulid == value.ulid
            )
        },
        handleClick(value) {
            if (!this.isSelected(value)) {
                this.toggle(value)
            }
        },
        toggle(value) {
            if (this.readOnly) {
                return
            }

            this.$emit('toggle', value)
        },
    },
    props: {
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        currentValue: {
            type: Object,
            required: true,
        },
        values: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
}
</script>
